
























































































import { Observer } from "mobx-vue";
import { reaction, IReactionDisposer } from "mobx";
import { Component, Vue } from "vue-property-decorator";
import videoRequestStore from "@/store/videoRequestStore";
import { VideoRequestStatus } from "@/api/VideoRequest";
import VideoRequestViewDialog from "@/components/VideoRequests/VideoRequestViewDialog.vue";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { videoUrl } from "@/api/VideoRequest";
import userStore from "@/store/userStore";
import { dateExact, timeExact, datetimeExact } from "@/filters/DateExact";

@Observer
@Component({ components: { VideoRequestViewDialog } })
class VideoRequestList extends Vue {
  videoRequestStore = videoRequestStore;
  formatDistanceToNow = formatDistanceToNow;
  VideoRequestStatus = VideoRequestStatus;
  userStore = userStore;
  private reactionDisposer: IReactionDisposer | null = null;
  private suppressReaction = false;

  created() {
    // Seed store options from localStorage before the table renders (mutate properties only)
    const sortBy = localStorage.getItem("videoRequestSortBy");
    const sortDesc = localStorage.getItem("videoRequestSortDesc");
    const itemsPerPage = localStorage.getItem("videoRequestItemsPerPage");
    const opts = this.videoRequestStore.options;
    opts.page = 1;
    opts.itemsPerPage = itemsPerPage ? Number(itemsPerPage) : 10;
    opts.sortBy = sortBy && JSON.parse(sortBy).length ? JSON.parse(sortBy) : ["requestedAt"];
    opts.sortDesc = sortDesc && JSON.parse(sortDesc).length ? JSON.parse(sortDesc) : [true];
    opts.groupBy = [];
    opts.groupDesc = [];
    opts.multiSort = false;
    opts.mustSort = true;
    // MobX reaction for localStorage persistence
    this.reactionDisposer = reaction(
      () => ({
        sortBy: this.videoRequestStore.options.sortBy.slice(),
        sortDesc: this.videoRequestStore.options.sortDesc.slice(),
        itemsPerPage: this.videoRequestStore.options.itemsPerPage
      }),
      opts => {
        localStorage.setItem("videoRequestSortBy", JSON.stringify(opts.sortBy));
        localStorage.setItem("videoRequestSortDesc", JSON.stringify(opts.sortDesc));
        localStorage.setItem("videoRequestItemsPerPage", String(opts.itemsPerPage));
      }
    );
    // Trigger initial data load only if not already loading
  }

  beforeDestroy() {
    if (this.reactionDisposer) {
      this.reactionDisposer();
    }
  }

  headers = [
    {
      text: "Address",
      value: "title"
    },

    {
      text: "Status",
      value: "status"
    },

    {
      text: "Date",
      value: "date"
    },

    {
      text: "From",
      value: "startAt",
      sortable: false
    },
    {
      text: "To",
      value: "endAt",
      sortable: false
    },
    {
      text: "Truck Code",
      value: "truckCode"
    },
    {
      text: "Requested",
      value: "requestedAt"
    },
    {
      text: "Completed",
      value: "completedAt"
    },
    {
      text: "Expires",
      value: "videoExpiresAt"
    },
    {
      text: "",
      value: "actions",
      sortable: false,
      width: "1%"
    }
  ];
  selectedVideoUrl = "";
  isVideoOpen = false;

  getStatusText(status: VideoRequestStatus) {
    switch (status) {
      case VideoRequestStatus.InProgress:
        return "Pending";
      case VideoRequestStatus.Complete:
        return "Complete";
      case VideoRequestStatus.Failed:
        return "Failed";
    }
  }

  viewPropertyVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Left");
    this.isVideoOpen = true;
  }

  viewRearVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Rear");
    this.isVideoOpen = true;
  }

  viewFrontVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Front");
    this.isVideoOpen = true;
  }

  viewHopperVideo(videoRequestId: number) {
    this.selectedVideoUrl = videoUrl(videoRequestId, "Inside");
    this.isVideoOpen = true;
  }

  onVideoRequestViewDialogClose() {
    setTimeout(() => {
      this.selectedVideoUrl = "";
    }, 300);
    this.isVideoOpen = false;
  }

  formatDateExact(value: string | null) {
    return dateExact(value);
  }

  formatTimeExact(value: string | null) {
    return timeExact(value);
  }

  formatDateTimeExact(value: string | null) {
    return datetimeExact(value);
  }
}

export default VideoRequestList;
